import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const BaseContactBox = memo(
  ({
    value,
    classNames,
    linkHref,
    onClickHandler,
    boxText,
    isArrow,
    rel,
    target,
    download
  }) => {
    const classes = cn(
      'contact-box',
      { 'contact-box--with-arrow': isArrow },
      { 'contact-box--no-text': !boxText },
      classNames
    );

    if (linkHref === '#') {
      return (
        <div className={classes}>
          <span className="contact-box__value">{value}</span>
        </div>
      );
    }

    const onClick = e => {
      if (typeof onClickHandler === 'function') {
        return onClickHandler(e, 'contact');
      }

      return null;
    };

    return (
      <a
        href={linkHref}
        data-stat={`residence-${classNames}`}
        className={classes}
        onClick={onClick}
        {...{ rel, target, download }}
      >
        <span className="contact-box__value">{value}</span>
        {boxText && <span className="contact-box__text">{boxText}</span>}
      </a>
    );
  }
);

BaseContactBox.displayName = 'BaseContactBox';

BaseContactBox.propTypes = {
  linkHref: PropTypes.string.isRequired,
  boxText: PropTypes.string,
  value: PropTypes.string,
  onClickHandler: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.string,
  download: PropTypes.bool,
  agencyPage: PropTypes.bool,
  isArrow: PropTypes.bool,
  classNames: PropTypes.string
};

export default BaseContactBox;
